module.exports = __webpack_public_path__ + "img/menucn_5_7.5b1763fd.svg";